import React from 'react'
import Field from '../../common/FormField'
import Gallery from '../../common/Gallery'

const StoreGallery = props =>
  <fieldset>
    {/*
    <Field type='toggle'>
      <input type='checkbox' defaultChecked disabled={disabled} />
      <i data-swchon-text='ON' data-swchoff-text='OFF' />Visibility on Public Store Profile
    </Field>
    <section>
      <label className='label'>Gallery Title</label>
      <label className='note'>
        Give your gallery a more specific name if showing a specific group of images.
      </label>
      <div className='row'>
        <div className='col col-4'>
          <label className='radio'>
            <input type='radio' name='galleryTitleGroup' value='gallery' defaultChecked disabled={disabled} />
            <i />Store Gallery
          </label>
        </div>
        <div className='col col-4'>
          <label className='radio'>
            <input type='radio' name='galleryTitleGroup' value='portfolio' disabled={disabled} />
            <i />Design Portfolio
          </label>
        </div>
      </div>
    </section>
    */}
    <Gallery {...props} imageType="retailer" />
  </fieldset>

export default StoreGallery
